import * as rx from 'rxjs'
import { concatMap, map, catchError } from 'rxjs/operators'
import { refreshTokenObservable } from './refreshTokenObservable'
import * as S from 'sanctuary'

export function createTokenQueue({
  getToken,
  getMaKey,
  updateAccessToken,
  removeToken,
  performRefreshToken,
  getDate,
}) {
  const tokenQueueSubject = new rx.Subject()

  tokenQueueSubject
    .pipe(
      concatMap((cb) =>
        refreshTokenObservable({
          getToken,
          getMaKey,
          updateAccessToken,
          performRefreshToken,
          removeToken,
          getDate,
        }).pipe(
          map((token) => {
            return [S.Right(token), cb]
          }),
          catchError((error) => {
            return rx.of([S.Left(error), cb])
          }),
        ),
      ),
    )
    .subscribe({
      next: ([eithertoken, cb]) => {
        cb(eithertoken)
      },
    })

  const addQueue = () => {
    return new Promise((resolve, reject) => {
      tokenQueueSubject.next(
        S.ifElse(S.isRight)(S.compose(resolve)(eitherToValue))(
          S.compose(reject)(eitherToValue),
        ),
      )
    })
  }

  return { addQueue }
}

const eitherToValue = S.either(S.I)(S.I)
